import React from 'react';
import { renderIconByLabel } from '../../content/icons';
import { Checkbox } from '../form/checkbox';

export const ConditionCheckbox = props => {
  const { condition, updateField, canInteract = true } = props;

  const isRadio =
    typeof condition?.group === 'string' && condition.group.trim() !== '';
  const isActive = condition?.state === 'active';
  const iconName = condition?.[condition?.state]?.icon;
  const iconElement = iconName
    ? renderIconByLabel(iconName, { size: 14 })
    : null;
  const label =
    condition?.active?.label ||
    condition?.inactive?.label ||
    condition?.label ||
    '';

  return (
    <div className='w-full h-full flex items-center justify-center p-1'>
      <Checkbox
        type={isRadio ? 'radio' : 'checkbox'}
        checked={isActive}
        icon={iconElement}
        label={label}
        className='w-full rounded px-075 py-05'
        labelClassName='uppercase font-condensed'
        disabled={!canInteract}
        onChange={() =>
          canInteract && updateField(isActive ? 'inactive' : 'active', 'state')
        }
      />
    </div>
  );
};
